import { Box, AHIcon } from "arkh";

import { useFragment, graphql } from "react-relay";
import { FilterButtonTodoTags, FilterButtonMe } from "widgets";
import { TodoCategoryScreenFilter_todoCategory$key } from "./__generated__/TodoCategoryScreenFilter_todoCategory.graphql";
import { TodoCategoryScreenFilter_employee$key } from "./__generated__/TodoCategoryScreenFilter_employee.graphql";

export function TodoCategoryScreenFilter(props: {
  todoCategory: TodoCategoryScreenFilter_todoCategory$key;
  employee: TodoCategoryScreenFilter_employee$key | null;
  selectedTagIds: string[];
  setSelectedTagIds: (tagIds: string[]) => void;
  onSetAssignedToMe: (assignedToMe: boolean) => void;
  isAssignedToMe: boolean;
}) {
  const employee = useFragment(
    graphql`
      fragment TodoCategoryScreenFilter_employee on Employee {
        id
        ...FilterButtonMe_employee
      }
    `,
    props.employee
  );
  const todoCategory = useFragment(
    graphql`
      fragment TodoCategoryScreenFilter_todoCategory on TodoCategory {
        tags {
          id
          ...FilterButtonTodoTags_tags
        }
      }
    `,
    props.todoCategory
  );

  return (
    <Box
      style={{
        flexDirection: "row",
        alignItems: "center",
        borderBottomWidth: 1,
      }}
      gap="small"
      color="surface"
      spaceBottom="small"
      spaceTop="xxsmall"
      spaceHorizontal="medium"
      borderColor="border-primary"
    >
      <AHIcon type="filter" />
      {employee ? (
        <FilterButtonMe
          employee={employee ?? null}
          onSetSelected={props.onSetAssignedToMe}
          isSelected={props.isAssignedToMe}
        />
      ) : null}
      <FilterButtonTodoTags
        tags={todoCategory.tags}
        selectedTagIds={props.selectedTagIds}
        setSelectedTagIds={props.setSelectedTagIds}
      />
    </Box>
  );
}
